import React from 'react'
import { withRouter, Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { withApollo } from 'react-apollo'
import { flowRight as compose } from 'lodash'

const DivContainer = glamorous.div({
  margin: '0 10px 24px 10px',
  '@media only screen and (maxWidth: 768px)': {
    margin: '0 6px 24px 6px',
  },
})

const GiftCardDiv = glamorous.div({
  width: '160px',
})

const Img = glamorous.img({
  width: '160px',
  height: '101px',
  marginBottom: '12px',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
})

const Name = glamorous.div({
  color: '#212529',
  paddingBottom: '6px',
  textAlign: 'center',
})

const Title = glamorous.h2(
  {
    paddingLeft: '12px',
    paddingBottom: '24px',
    fontSize: '18px',
    fontWeight: '300',
    color: '#4a4a4a',
  },
  'vx_text-body-lg',
)

const DisplayDiv = glamorous.div({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-evenly',
})

const EmptyItem = glamorous.div({
  margin: '0 10px',
  width: '160px',
  '@media only screen and (maxWidth: 768px)': {
    margin: '0 6px',
  },
})

class GiftCardsList extends React.Component {
  static propTypes = {
    basepath: PropTypes.string,
    items: PropTypes.array.isRequired,
    title: PropTypes.string,
    history: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
    centerAlign: PropTypes.string,
  }

  addCardClickTrackingProps = ({ name }) => {
    // only track card click if from /gifts/all
    const fromAllGiftCards = window.location.pathname.includes('/gifts/all')
    if (!fromAllGiftCards) {
      return {}
    }

    return {
      'data-pagename': 'main:consumer:gifts:home:',
      'data-pagename2': 'main:consumer:gifts:home:allgifts:::',
      'data-extra': JSON.stringify({
        pp_flow: encodeURIComponent(name),
      }),
    }
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        {this.props.title && (
          <Title style={this.props.centerAlign && { textAlign: 'center' }}>
            {this.props.title}
          </Title>
        )}
        <DisplayDiv>
          {this.props.items &&
            this.props.items
              .filter(i => i)
              .map((item, idx) => {
                return (
                  <DivContainer key={item.id}>
                    <Link
                      tabIndex={idx + 1}
                      to={`${this.props.basepath || ''}${item.url_key}`}
                      data-linkname="Card"
                      {...this.addCardClickTrackingProps(item)}
                    >
                      <GiftCardDiv>
                        <Img src={item.img_url} alt={item.name} />
                        <Name className="vx_text-body-sm">{item.name}</Name>
                      </GiftCardDiv>
                    </Link>
                  </DivContainer>
                )
              })}
          <EmptyItem />
          <EmptyItem />
          <EmptyItem />
        </DisplayDiv>
      </div>
    )
  }
}

const GiftCardsListWithGraphql = compose(withApollo)(withRouter(GiftCardsList))
export default GiftCardsListWithGraphql
